import React from 'react';

import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        alignItems: 'center',
        gap: '30px',
        backgroundColor: '#E7FEEB',
        border: 'none',
        padding: '20px 24px',
        width: '100%',
        cursor: 'pointer',
        color: '#067A0D',
        boxSizing: 'border-box',
        font: 'inherit',
        textAlign: 'left'
    },
    icon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#067A0D',
        borderRadius: '50%',
        color: '#FFFFFF',
        minWidth: '40px',
        height: '40px',
        '& i': {
            fontSize: '16px'
        }
    },
    content: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        gap: '4px'
    },
    title: {
        fontSize: '20px',
        fontWeight: 700,
        lineHeight: '27px'
    },
    subtitle: {
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '22px'
    },
    chevron: {
        fontSize: '16px'
    }
}));

type CompletedSummaryProps = {
    onExpand: () => void;
    subtitle: string;
    title: string;
};

const CompletedSummary: React.FC<CompletedSummaryProps> = ({
    onExpand,
    subtitle,
    title
}) => {
    const classes = useStyles();

    return (
        <button
            className={classes.container}
            onClick={onExpand}
            type="button"
        >
            <div className={classes.icon}>
                <i className="fas fa-check" />
            </div>
            <div className={classes.content}>
                <span className={classes.title}>{title}</span>
                <span className={classes.subtitle}>{subtitle}</span>
            </div>
            <i className={`fas fa-chevron-down ${classes.chevron}`} />
        </button>
    );
};

export default CompletedSummary;
